import { currency } from "../services/common.service";
import { InputContainer } from "./form/form.module";
import { InputLabelContainer } from "./form/label/containers/input-label.container";


export const PaymentStatusActionMobileComponent = ({
    value,
    onPaymentFormChange,
    dataId,
    paymentValues,
    paymentLibrary
}: any) => {

    console.log(dataId, 'dataId')
    return (
        <>
            {(dataId?.PaymentMethodId === 10 && value !== 30) ? (
                <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3">
                        {/* Order Total */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputLabelContainer label="Order Total" className="text-sm text-gray-500" />
                            <div className="text-lg font-bold text-gray-900">
                                {`₹ ${dataId?.OrderTotal}`}
                            </div>
                        </div>

                        {/* Balance Amount */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputLabelContainer label="Balance Amount" className="text-sm text-gray-500" />
                            <div className="text-lg font-bold text-gray-900">
                                {`₹ ${dataId?.BalanceAmount || 0} `}
                            </div>
                        </div>

                        {/* Payment Status */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputContainer
                                label="Payment Status"
                                labelField="Text"
                                list={paymentLibrary}
                                onValueChange={(event: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaymentStatusId'
                                    });
                                }}
                                type="select"
                                optionName="Choose Payment Status"
                                value={paymentValues?.PaymentStatusId || value}
                                valueField="Value"
                            />
                        </div>

                        {/* Paid Amount */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputContainer
                                label="Paid Amount"
                                name="PaidAmount"
                                onValueChange={(event: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaidAmount'
                                    });
                                }}
                                type="number"
                                value={paymentValues?.PaidAmount}
                            />
                        </div>
                    </div>
                </>
            ) :
                <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3">
                        {/* Order Total */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputLabelContainer label="Order Total" className="text-sm text-gray-500" />
                            <div className="text-lg font-bold text-gray-900">
                                {`₹ ${dataId?.OrderTotal}`}
                            </div>
                        </div>

                        {/* Balance Amount */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputLabelContainer label="Balance Amount" className="text-sm text-gray-500" />
                            <div className="text-lg font-bold text-gray-900">
                                {`₹ ${dataId?.BalanceAmount || 0} `}
                            </div>
                        </div>

                        {/* Payment Status */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputContainer
                                isDisabled
                                label="Payment Status"
                                labelField="Text"
                                list={paymentLibrary}
                                onValueChange={(event: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaymentStatusId'
                                    });
                                }}
                                type="select"
                                optionName="Choose Payment Status"
                                value={paymentValues?.PaymentStatusId || value}
                                valueField="Value"
                            />
                        </div>

                        {/* Paid Amount */}
                        <div className="bg-white rounded-lg shadow-sm border p-2 md:border-0 md:shadow-none">
                            <InputContainer
                                isDisabled
                                label="Paid Amount"
                                name="PaidAmount"
                                onValueChange={(event: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaidAmount'
                                    });
                                }}
                                type="number"
                                value={dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal}
                            />
                        </div>
                    </div></>
            }
        </>







    );
};
